import React from 'react';
import { Redirect } from 'react-router-dom';
import { LOGIN_URL } from '../../constants/url';

const LoginRedirect = () => (
  <Redirect to={LOGIN_URL} />
);

export default LoginRedirect;
